export const REQUEST_LOAD = 'SETTINGS/REQUEST_LOAD';
export const RECEIVE_NAMESPACES = 'SETTINGS/NAMESPACES_RECEIVE';
